/**
 * @generated SignedSource<<0e98690ebf57b4de74b626fcdb1890d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type RecurringRequestExclusionReason = "AGENDA_UNAVAILABLE" | "REQUEST_NOT_AVAILABLE";
export type RequestRecurrenceEndCondition = "AFTER_OCCURRENCES" | "ON_DATE";
export type RequestRecurrenceType = "DAY" | "MONTH" | "WEEK";
export type RequestRestrictionType = "BLOCK" | "EVENT" | "RESTRICTION";
export type RoundType = "CUSTOMER" | "GUEST" | "MEMBER";
export type PreviewPatronRequestSeriesInput = {
  recurrence: PatronRequestRecurrenceInput;
  request?: RequestInput | null | undefined;
  sourceArgs?: PatronRequestPreviewSourceArgsInput | null | undefined;
  sourceBookingId: string;
};
export type PatronRequestRecurrenceInput = {
  endCondition: RequestRecurrenceEndCondition;
  endDate?: string | null | undefined;
  occurrenceCount?: number | null | undefined;
  recurrenceType: RequestRecurrenceType;
  repeatInterval: number;
};
export type RequestInput = {
  bookingRuleId?: string | null | undefined;
  id?: string | null | undefined;
  maxTime: string;
  minTime: string;
  requestCoursePreferences?: ReadonlyArray<RequestCoursePreferenceInput> | null | undefined;
  time: string;
};
export type RequestCoursePreferenceInput = {
  courseBucketId?: string | null | undefined;
  courseId?: string | null | undefined;
};
export type PatronRequestPreviewSourceArgsInput = {
  durationMins?: number | null | undefined;
  ownerMemberId?: string | null | undefined;
  rounds?: ReadonlyArray<PatronRequestPreviewRoundInput> | null | undefined;
  type?: BookingType | null | undefined;
};
export type PatronRequestPreviewRoundInput = {
  bookingIndex?: number | null | undefined;
  courseLayoutId?: string | null | undefined;
  hostId?: string | null | undefined;
  nonPlayingHost?: boolean | null | undefined;
  playerId?: string | null | undefined;
  rateId?: string | null | undefined;
  secondaryTransportationTypeId?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
  type: RoundType;
};
export type useRecurringRequestSeriesPreviewMutation$variables = {
  input: PreviewPatronRequestSeriesInput;
};
export type useRecurringRequestSeriesPreviewMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly excluded: ReadonlyArray<{
      readonly conflict: {
        readonly endAt: string;
        readonly label: string;
        readonly startAt: string;
        readonly type: RequestRestrictionType;
      } | null | undefined;
      readonly date: string;
      readonly reason: RecurringRequestExclusionReason;
      readonly requestOpensDate: string | null | undefined;
    }> | null | undefined;
    readonly included: ReadonlyArray<{
      readonly date: string;
      readonly warnings: ReadonlyArray<{
        readonly endAt: string;
        readonly label: string;
        readonly startAt: string;
        readonly type: RequestRestrictionType;
      }> | null | undefined;
    }> | null | undefined;
    readonly proposedRemovals: ReadonlyArray<{
      readonly date: string;
    }> | null | undefined;
    readonly reviewedPlanToken: string | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useRecurringRequestSeriesPreviewMutation = {
  response: useRecurringRequestSeriesPreviewMutation$data;
  variables: useRecurringRequestSeriesPreviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewedPlanToken",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endAt",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "RecurringRequestOccurrence",
  "kind": "LinkedField",
  "name": "included",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RequestRestrictionStatus",
      "kind": "LinkedField",
      "name": "warnings",
      "plural": true,
      "selections": (v6/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "RecurringRequestExclusion",
  "kind": "LinkedField",
  "name": "excluded",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestOpensDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RequestRestrictionStatus",
      "kind": "LinkedField",
      "name": "conflict",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "RecurringRequestOccurrence",
  "kind": "LinkedField",
  "name": "proposedRemovals",
  "plural": true,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRecurringRequestSeriesPreviewMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "PreviewPatronRequestSeriesPayload",
        "kind": "LinkedField",
        "name": "previewPatronRequestSeries",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRecurringRequestSeriesPreviewMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "PreviewPatronRequestSeriesPayload",
        "kind": "LinkedField",
        "name": "previewPatronRequestSeries",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f94629e8231a0b3a07e0e5a7a60a871c",
    "id": null,
    "metadata": {},
    "name": "useRecurringRequestSeriesPreviewMutation",
    "operationKind": "mutation",
    "text": "mutation useRecurringRequestSeriesPreviewMutation(\n  $input: PreviewPatronRequestSeriesInput!\n) {\n  responsePayload: previewPatronRequestSeries(input: $input) {\n    success\n    errors {\n      __typename\n      message\n    }\n    reviewedPlanToken\n    included {\n      date\n      warnings {\n        type\n        label\n        startAt\n        endAt\n      }\n    }\n    excluded {\n      date\n      reason\n      requestOpensDate\n      conflict {\n        type\n        label\n        startAt\n        endAt\n      }\n    }\n    proposedRemovals {\n      date\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f95755869618c1831e4a1a4398e54daa";

export default node;
